export default __webpack_public_path__ + "static/tag-do-5-light-cb82ac28ef062fb4cecfc0d095d2a9e4390b9baae26a222ad3dec625bb2d1290.png";